import React from 'react';
import {BrowserRouter} from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import App from './App.js';
import {APP_VERSION} from './utils/appVersion.js';

// Verzi klienta posíláme se všemi axios requesty, server si ji ukládá k session.
axios.defaults.headers.common['X-App-Version'] = APP_VERSION;

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
	<BrowserRouter>
		<App />
	</BrowserRouter>
);

if ('serviceWorker' in navigator) {
	window.addEventListener('load', () => {
		navigator.serviceWorker.register('/sw.js').catch((error) => {
			console.error(error);
		});
	});
}